'use strict';
/** @typedef {import('./generated-types').CodecName} CodecName */

/** @typedef {import('./generated-types').NumberNameMap} NumberNameMap */

var _slicedToArray = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('./base-table'),
    baseTable = _require.baseTable;

var tableByCode =
/** @type {NumberNameMap} */
{};

for (var _i = 0, _Object$entries = Object.entries(baseTable); _i < _Object$entries.length; _i++) {
  var _ref3 = _Object$entries[_i];

  var _ref2 = _slicedToArray(_ref3, 2);

  var name = _ref2[0];
  var code = _ref2[1];

  if (tableByCode[code] === undefined) {
    tableByCode[code] =
    /** @type {CodecName} **/
    name;
  }
}

module.exports =
/** @type {NumberNameMap} */
Object.freeze(tableByCode);